export default function lookUpBlockID(lookupID) {
  return fetch(`/api/block/${lookupID}`)
    .then(resp => resp.json());
}



// WEBPACK FOOTER //
// ./src/util/lookUpBlockID.js